import { arrayOf, shape } from "prop-types";
import { memo } from "react";

import { SkeletonProductCategories } from "web/Layout/Common/SkeletonComponents";

import List from "./list";

const Container = memo(({ categories, facets }) => {
  if (facets.length) {
    const facet = facets.find((facetItem) => facetItem.code === "category_ids");

    return <List categories={categories} facet={facet} />;
  }

  return <SkeletonProductCategories />;
});

Container.propTypes = {
  categories: arrayOf(shape()).isRequired,
  facets: arrayOf(shape({})),
};

Container.defaultProps = {
  facets: [],
};

export default Container;
